import React, { useContext, useEffect, useState, memo } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { compose } from 'redux';

import connectProps from 'fantastic/lib/connectProps';
import connectActions from 'fantastic/lib/connectActions';
import actions from 'fantastic/actions';

import BackButton from './header/BackButton';
import HelpButton from './header/HelpButton';
import NextStepButton from './header/NextStepButton';
import PreviewButton from './header/PreviewButton';
import HistoryNavigationButtons from './header/HistoryNavigationButtons';
import ClientsPreviewButton from 'shared/components/buttons/ClientsPreviewButton';
import TemplatesButton from 'shared/components/buttons/TemplatesButton';
import SendTestModal from 'shared/components/send_test/SendTestModal';
import SettingsContext from 'shared/lib/SettingsContext';
import PreviewContext from 'fantastic/lib/PreviewContext';
import Dropdown from 'shared/components/Dropdown';
import Toggle from '../common/Toggle';
import isLightTheme from 'fantastic/lib/isLightTheme';
import DayNightToggle from '../common/DayNightToggle';
import CustomBackButtons from './header/CustomBackButtons';
import CustomNextButton from './header/CustomNextButton';
import RegistrationNoticeModal from '../common/RegistrationNoticeModal';

const Header = ({
  settings,
  preview,
  sections,
  theme: { style_attributes },
  app: { preview_mode, theme_mode, savingInProgress },
  previewMode,
  setThemeMode,
}) => {
  const { test_mode, standalone_mode, template_active, save_as_template_url } = settings;
  const creatorMode = settings && settings.creator_mode;
  const canPublish = standalone_mode && !template_active;

  const [sendTest, showSendTest] = useState(false);
  const [showRegistrationNotice, setShowRegistrationNotice] = useState(false);

  const testingNotice = () => {
    setShowRegistrationNotice(true);
  };

  const sendTestHandle = () => {
    if (savingInProgress) return;
    if (test_mode) return testingNotice();

    showSendTest(true);
  };

  const sendRealHandle = () => {
    if (savingInProgress) return;
    if (test_mode) return testingNotice();

    const next_url = canPublish ? null : settings.next_url;
    window.etLoader.show(settings.id, next_url);
  };

  const headerClasses = classNames('fantastic-header', {
    /*affix,*/ 'fantastic-header--dark': preview_mode === 'dark',
  });

  const testingLinksClasses = classNames('fantastic-header__sendtest-link', {
    disabled: savingInProgress || test_mode,
  });

  useEffect(() => {
    if (preview) {
      const mode = isLightTheme(style_attributes['base-bg'], style_attributes['base-font-color']) ? 'light' : 'dark';
      previewMode(mode);
      setThemeMode(mode);
    }
  }, [preview]);

  const Version = () => (
    <div className="fantastic-version">
      v{settings.template_id}.{settings.lock_version}
    </div>
  );

  return (
    <>
      {sendTest && (
        <SettingsContext.Provider value={settings}>
          <SendTestModal closeModal={() => showSendTest(false)} />
        </SettingsContext.Provider>
      )}
      <RegistrationNoticeModal isOpen={showRegistrationNotice} onClose={() => setShowRegistrationNotice(false)} />

      <div className={headerClasses}>
        <div className="left">
          {settings.prev_url && <BackButton prev_url={settings.prev_url} only={test_mode} />}
          {settings.prev_custom && <CustomBackButtons buttons={settings.prev_custom} />}
          {!standalone_mode && (
            <TemplatesButton
              templates_url={settings.templates_url}
              save_as_template_url={save_as_template_url}
              template_id={settings.template_id}
            />
          )}
          <HelpButton />
          {creatorMode && preview && (
            <div>
              <small className="btn btn-link disabled">Detected current theme is {theme_mode}.</small>
            </div>
          )}
        </div>
        <div className="right">
          {preview ? (
            <>
              <DayNightToggle
                value={preview_mode === 'light'}
                inside={true}
                on={i18n.t('theme')}
                off={i18n.t(preview_mode)}
                onChange={(val) => previewMode(val ? 'light' : 'dark')}
              />
              <PreviewButton preview={preview} />
            </>
          ) : (
            <>
              <HistoryNavigationButtons />
              <Dropdown
                name={
                  <>
                    <i className="fi fi-check"></i>
                    {i18n.t('send_test.button')}
                  </>
                }
                klass="btn btn-form btn-with-icon"
                extraMainClass="template-testing-dropdown"
                icon="caret"
                withFinish={false}
              >
                <Link to="/preview" className="fantastic-header__sendtest-link">
                  <div>
                    <i className="fi fi-eye" />
                  </div>
                  <div>
                    <strong>{i18n.t('header.preview')}</strong>
                    <span>{i18n.t('header.preview_desc')}</span>
                  </div>
                </Link>
                <a onClick={sendTestHandle} className={testingLinksClasses}>
                  <div>
                    <i className="fi fi-envelope-fly" />
                  </div>
                  <div>
                    <strong>{i18n.t('header.send_test')}</strong>
                    <span>{i18n.t('header.send_test_desc')}</span>
                  </div>
                </a>
                <a onClick={sendRealHandle} className={testingLinksClasses}>
                  <div>
                    <i className="fi fi-lap-mobile" />
                  </div>
                  <div>
                    <strong>{i18n.t('header.clients')}</strong>
                    <span>{i18n.t('header.clients_desc')}</span>
                  </div>
                </a>
                {test_mode && (
                  <div className="fantastic-header__alert">
                    <i className="fi fi-alert" />
                    {i18n.t('header.unavailable')}
                  </div>
                )}
              </Dropdown>
            </>
          )}
          {settings.next_custom ? <CustomNextButton /> : <NextStepButton />}
          <Version />
        </div>
      </div>
    </>
  );
};
export default compose(
  connectProps('settings', 'theme', 'app'),
  connectActions({
    previewMode: actions.previewMode,
    setThemeMode: actions.setThemeMode,
  })
)(Header);
